var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "goods-promotion-tags" },
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "card" },
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "全部", name: "all" } },
            [
              _c("goods-promotion-table-pane", {
                ref: "goodsPromotionAll",
                attrs: { "goods-promotion-type": 0 },
                on: {
                  toConfig: _vm.handleToConfig,
                  toEdit: _vm.handleToEditConfig,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "促销中", name: "active" } },
            [
              _vm.activeName === "active"
                ? _c("goods-promotion-table-pane", {
                    ref: "goodsPromotionActive",
                    attrs: { "goods-promotion-type": 1 },
                    on: {
                      toConfig: _vm.handleToConfig,
                      toEdit: _vm.handleToEditConfig,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "未促销", name: "inActive" } },
            [
              _vm.activeName === "inActive"
                ? _c("goods-promotion-table-pane", {
                    ref: "goodsPromotionInActive",
                    attrs: { "goods-promotion-type": 2 },
                    on: {
                      toConfig: _vm.handleToConfig,
                      toEdit: _vm.handleToEditConfig,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _vm.activeName === "config"
            ? _c(
                "el-tab-pane",
                { attrs: { label: "配置商品促销", name: "config" } },
                [
                  _c("goods-promotion-cfg-pane", {
                    ref: "goodsPromotionCfg",
                    attrs: {
                      "goods-list": _vm.goodsList,
                      "fn-id": _vm.editFnId,
                    },
                    on: { success: _vm.handleSuccess },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }